import { render } from "./RaportsTable.vue?vue&type=template&id=1f6a3fe1&scoped=true&ts=true"
import script from "./RaportsTable.vue?vue&type=script&lang=ts"
export * from "./RaportsTable.vue?vue&type=script&lang=ts"

import "./RaportsTable.vue?vue&type=style&index=0&id=1f6a3fe1&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a3fe1"]])

export default __exports__